export const ANNUAL_REPORT_DASHBOARD_SUCCESS = 'ANNUAL_REPORT_DASHBOARD_SUCCESS';
export const ANNUAL_REPORT_DASHBOARD_FAILURE = 'ANNUAL_REPORT_DASHBOARD_FAILURE';

export const ANNUAL_REPORT_REOPEN_SUCCESS = 'ANNUAL_REPORT_REOPEN_SUCCESS';
export const ANNUAL_REPORT_REOPEN_FAILURE = 'ANNUAL_REPORT_REOPEN_FAILURE';
